import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function respuestaReducer(state= initialState.respuesta, action){
    let newState;
	switch(action.type){
         case types.LOAD_RESPUESTA_LIST_SUCCESS:		
            action.respuesta.filtroActivo=state.filtroActivo;
            action.respuesta.filtroActual=state.filtroActual;
            action.respuesta.showActivos=state.showActivos;
			 action.respuesta.paginaActual=action.respuesta.pageable.pageNumber;
			 action.respuesta.registrosPorPagina=action.respuesta.size;
            
            return action.respuesta;

        case types.BORRAR_RESPUESTA_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(respuesta => respuesta.id !== action.respuesta.id)];          
			return newState;    
            
        case types.ACTIVAR_RESPUESTA_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(respuesta => respuesta.id !== action.respuesta.id)];          
			 return newState;
            
        case types.SET_FILTRO_RESPUESTA:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
            newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}